// extracted by mini-css-extract-plugin
export default {"content":"ComboCampaign_content__7s1MU","campaignImg":"ComboCampaign_campaignImg__GX2j0"};